import { isNull } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { ColumnSort, TableFilters } from '../../../shared/table/types';
import { DoraConfiguration, DoraFunction, DoraFunctionUsage, FunctionToDelete, DoraConfigurationTimeline } from './types';
import { DropdownOption } from '../../../shared/dropdown/Dropdown';
import { getDoraFunctionsRoot } from '../../store/selectors';

export const getAllDoraFunctions = (state: ApplicationState): DoraFunction[] => getDoraFunctionsRoot(state).doraFunctions;

export const getIsFetchingFunctions = (state: ApplicationState): boolean => getDoraFunctionsRoot(state).fetchingFunctions;

export const getDoraFunctionModalOpen = (state: ApplicationState): boolean => !isNull(getDoraFunctionsRoot(state).selectedDoraFunction);

export const getSelectedDoraFunction = (state: ApplicationState): DoraFunction | null => getDoraFunctionsRoot(state).selectedDoraFunction;

export const getCurrentDoraFunction = (state: ApplicationState): DoraFunction | null => getDoraFunctionsRoot(state).currentDoraFunction;

export const getDoraFunctionDropdownOptions = (state: ApplicationState): DropdownOption[] => {
    const doraFunctions = getDoraFunctionsRoot(state).doraFunctions;
    return doraFunctions.map(({ name }) => ({ value: name, label: name }));
};

export const getIsSavingDoraFunction = (state: ApplicationState): boolean => getDoraFunctionsRoot(state).savingDoraFunction;

export const getFunctionConfigModalOpen = (state: ApplicationState): boolean => getDoraFunctionsRoot(state).functionConfigModalOpen;

export const getDoraFunctionConfig = (state: ApplicationState): DoraConfiguration => getDoraFunctionsRoot(state).doraFunctionConfiguration;
export const getCurrentDoraFunctionConfig = (state: ApplicationState): DoraConfiguration => getDoraFunctionsRoot(state).currentDoraFunctionConfiguration;

export const getSelectedTimelineConfiguration = (state: ApplicationState): DoraConfigurationTimeline | null => getDoraFunctionsRoot(state).timelineConfiguration;

export const getConfigurationTimeline = (state: ApplicationState): DoraConfigurationTimeline[] => getDoraFunctionsRoot(state).configurationTimeline;

export const getDeleteFunctionConfirmationModalOpen = (state: ApplicationState): boolean => !isNull(getDoraFunctionsRoot(state).functionToDelete) && !getDoraFunctionsRoot(state).fetchingFunctionUsage;

export const getFunctionToDelete = (state: ApplicationState): FunctionToDelete | null => getDoraFunctionsRoot(state).functionToDelete;

export const getFunctionToDeleteUsage = (state: ApplicationState): DoraFunctionUsage[] => getDoraFunctionsRoot(state).functionToDeleteUsage;

// Table Filters and Pagination
export const getTotalDoraFunctions = (state: ApplicationState): number => getDoraFunctionsRoot(state).totalDoraFunctions;
export const getDoraFunctionsFilters = (state: ApplicationState): TableFilters => getDoraFunctionsRoot(state).doraFunctionsFilters;
export const getDoraFunctionsColumnSort = (state: ApplicationState): ColumnSort | undefined => getDoraFunctionsRoot(state).doraFunctionsColumnSort;
export const getDoraFunctionsPageNumber = (state: ApplicationState): number => getDoraFunctionsRoot(state).doraFunctionsPage;
export const getDoraFunctionsPageSize = (state: ApplicationState): number => getDoraFunctionsRoot(state).doraFunctionsPageSize;
